export default __webpack_public_path__ + "static/media/icone.bbf4534f.png";